import React, { useEffect } from 'react';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import './VideoSlider.scss';
import VideoSlideItem from './VideoSlideItem';
import video1 from '../../../assets/videos/waiter.mp4';
import careerVideo from '../../../assets/videos/career-growth.mp4';
import poster1 from '../../../assets/videos/waiter-poster.jpg';


const VideoSlider = () => {
  const videoData = [
    { 
      id: 1, 
      isVideo: true, 
      src: video1, 
      poster: poster1, 
      title: "Официант 1"
    },
    { 
      id: 2, 
      isVideo: true,
      src: careerVideo,
      title: "Карьера в DOSKI"
    },
    { 
      id: 3, 
      isVideo: false
    },
    { 
      id: 4, 
      isVideo: true, 
      src: video1, 
      poster: poster1,
      title: "Официант 4"
    },
    { 
      id: 5, 
      isVideo: true, 
      src: video1, 
      poster: poster1, 
      title: "Официант 5"
    },
  ];

  useEffect(() => {
    const swiper = new Swiper('.swiper-job2', { //тот же класс, что и в разметке
      loop: true,
      on: {
        slideChange: function () {
          // Пауза всех видео при смене слайда
          const videos = document.querySelectorAll('.swiper-job2 video');
          videos.forEach(video => {
            if (!video.paused) {
              video.pause();
            }
          });
        },
      },
      breakpoints: {
        2500: {
          spaceBetween: 17,
          slidesPerView: 3,
        },
        2259: {
          spaceBetween: 14,
          slidesPerView: 3,
        },
        1441: {
          spaceBetween: 24,
          slidesPerView: 3,
        },
        1025: { //от 1025 и выше
          spaceBetween: 10,
          slidesPerView: 3,

        },
        767: {
          slidesPerView: 3, 
          spaceBetween: 15,
        },
        680: {
          slidesPerView: 3, 
          spaceBetween: 15,
        },
        600: {
          slidesPerView: 2.5,
          spaceBetween: 15,
        },
        450: {
          slidesPerView: 2.1,
          spaceBetween: 15,
        },
        376: { 
          slidesPerView: 1.6,
          spaceBetween: 15,
        },
        0: {
          spaceBetween: 15,
          slidesPerView: 1.5454545454, 
        }
      },
    });

    return () => {
      swiper.destroy(); // Очистка при размонтировании
    };
  }, []);

  return (
    <div className="swiper-wrapper-job2">
      <div className="swiper-job2" >

        <div className="swiper-wrapper">
          {videoData.map((item) => (
            <div className="swiper-slide" key={item.id}>
              <VideoSlideItem 
                isVideo={item.isVideo} 
                videoSrc={item.src}
                poster={item.poster}
                title={item.title}
              />
            </div>
          ))}
        </div>
        
      </div>
  </div>
  )
}

export default VideoSlider;
